import { t } from '../../../../infra/i18n';
export var formatWeekdayName = function (weekday) {
    var days = [
        t('engage:datepicker.days.sunday'),
        t('engage:datepicker.days.monday'),
        t('engage:datepicker.days.tuesday'),
        t('engage:datepicker.days.wednesday'),
        t('engage:datepicker.days.thursday'),
        t('engage:datepicker.days.friday'),
        t('engage:datepicker.days.saturday'),
    ];
    return days[weekday.getDay()].substring(0, 3);
};
export var formatMonthName = function (month) {
    var months = [
        t('engage:datepicker.months.january'),
        t('engage:datepicker.months.february'),
        t('engage:datepicker.months.march'),
        t('engage:datepicker.months.april'),
        t('engage:datepicker.months.may'),
        t('engage:datepicker.months.june'),
        t('engage:datepicker.months.july'),
        t('engage:datepicker.months.august'),
        t('engage:datepicker.months.september'),
        t('engage:datepicker.months.october'),
        t('engage:datepicker.months.november'),
        t('engage:datepicker.months.december'),
    ];
    return months[month.getMonth()];
};
export var parseDateToSimpleFormat = function (selectedDay, format) {
    if (!selectedDay)
        return undefined;
    var year = selectedDay.getFullYear();
    var month = selectedDay.getMonth() + 1;
    var day = selectedDay.getDate();
    var paddedMonth = month.toString().padStart(2, '0');
    var paddedDay = day.toString().padStart(2, '0');
    if (format === 'MM/dd/yyyy') {
        return "".concat(paddedMonth, "/").concat(paddedDay, "/").concat(year);
    }
    return "".concat(paddedDay, "/").concat(paddedMonth, "/").concat(year);
};
